import { handleActions, combineActions } from 'redux-actions';
import { TOGGLE_SIDEBAR, SET_IS_EXPANDED, INIT_VISIBILITY, TOGGLE_SIDEBAR_CLOSE_BUTTON } from './consts';
import { isMobileAny } from '../../../utils/device';
import { DEFAULT_VISIBILITY_STATE } from '../const';
import { getCookie } from '../../../utils/cookie';

let isExpanded = false;

if (!isMobileAny) {
	isExpanded = getCookie('sidebar_isExpandedView');
	const hasStoredValue = typeof isExpanded !== 'undefined' && isExpanded !== null;
	isExpanded = hasStoredValue ? JSON.parse(isExpanded) : DEFAULT_VISIBILITY_STATE;
}

const initialState = {
	isExpanded,
	isCloseButtonEnable: true,
};

export const sidebarReducer = handleActions(
	{
		[TOGGLE_SIDEBAR.ACTION]: (state) => ({
			...state,
			isExpanded: !state.isExpanded,
		}),
		[combineActions(SET_IS_EXPANDED.ACTION, INIT_VISIBILITY.ACTION)]: (state, { payload }) => ({
			...state,
			isExpanded: payload,
		}),
		[TOGGLE_SIDEBAR_CLOSE_BUTTON.ACTION]: (state, action) => ({
			...state,
			isCloseButtonEnable: action.payload,
		}),
	},
	initialState,
);
